import { AnalyticsShellModule } from '@analytics/shell';
import { NgModule } from '@angular/core';
import { CallbackShellModule } from '@callback/shell';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { CartShellEagerModule } from '@cart/shell';
import { CoreShellModule } from '@core/shell';
import { CoreSpartacusModule } from '@core/spartacus';
import { MainNavigationShellModule } from '@main/navigation/shell';
import { MainSchemaOrgFeatureModule } from '@main/schema-org/feature';
import { SdvorArticleShellModule } from '@sdvor/article/shell';
import { SdvorAvailabilityShellModule } from '@sdvor/availability/shell';
import { SdvorBadgeShellModule } from '@sdvor/badge/shell';
import { SdvorBetonShellModule } from '@sdvor/beton/shell';
import { SdvorCatalogShellModule } from '@sdvor/catalog/shell';
import { SdvorCityShellModule } from '@sdvor/city/shell';
import { SdvorCompanyShellModule } from '@sdvor/company/shell';
import { SdvorComparisonShellModule } from '@sdvor/comparison/shell';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { SdvorDeliveryShellModule } from '@sdvor/delivery/shell';
import { SdvorFeedbackShellModule } from '@sdvor/feedback/shell';
import { SdvorMainShellModule } from '@sdvor/main/shell';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { MyAccountShellEagerModule } from '@my-account/shell';
import { PromoShellEagerModule } from '@promo/shell';
import { SdvorMyShopShellModule } from '@sdvor/my-shop/shell';
import { SdvorPaymentShellModule } from '@sdvor/payment/shell';
import { SdvorProductShellModule } from '@sdvor/product/shell';
import { SdvorReferenceShellModule } from '@sdvor/reference/shell';
import { SdvorSearchShellModule } from '@sdvor/search/shell';
import { SdvorSeoShellModule } from '@sdvor/seo/shell';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { CheckoutShellEagerModule } from '@checkout/shell';
import { ReviewsShellModule } from '@reviews/shell';
import { SdvorSharedCmsComponentsModule } from '@sdvor/shared/ui';
import { SdvorUserShellModule } from '@sdvor/user/shell';
import { WishlistShellModule } from '@sdvor/wishlist/shell';
import { SharedServicesModule } from '@shared/services';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ShopShellEagerModule } from '@shop/shell';
import { AuthModule, ProductModule, ProductOccModule } from '@spartacus/core';
import {
  HamburgerMenuModule,
  JsonLdBuilderModule,
  ProductDetailsPageModule,
  ProductListingPageModule,
} from '@spartacus/storefront';
import { UserAccountCoreModule, UserAccountOccModule } from '@spartacus/user';
import { TrackingShellModule } from '@tracking/shell';
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module';

@NgModule({
  imports: [
    // Auth Core
    AuthModule.forRoot(),

    // Basic Cms Components

    HamburgerMenuModule,
    // CmsParagraphModule,

    UserAccountCoreModule,
    UserAccountOccModule,

    // Product Core
    ProductModule,
    ProductOccModule,

    // Product UI
    ProductDetailsPageModule,
    ProductListingPageModule,

    JsonLdBuilderModule,
    MainSchemaOrgFeatureModule,

    /** *********************** Spartacus features **********************/
    SmartEditFeatureModule,

    /** *********************** Customized Spartacus features **********************/
    CoreSpartacusModule,

    /** *********************** External features *************************/
    SdvorSharedCmsComponentsModule,
    SharedServicesModule,
    CoreShellModule,
    MainNavigationShellModule,
    SdvorCityShellModule,
    SdvorUserShellModule,
    TrackingShellModule,
    SdvorFeedbackShellModule,
    SdvorMyShopShellModule,
    SdvorArticleShellModule,
    AnalyticsShellModule,
    MyAccountShellEagerModule,
    SdvorMainShellModule,
    CartShellEagerModule,
    PromoShellEagerModule,
    ReviewsShellModule,
    SdvorAvailabilityShellModule,
    SdvorProductShellModule,
    SdvorCatalogShellModule,
    CheckoutShellEagerModule,
    SdvorComparisonShellModule,
    SdvorSearchShellModule,
    SdvorDeliveryShellModule,
    SdvorPaymentShellModule,
    SdvorCompanyShellModule,
    SdvorBadgeShellModule,
    WishlistShellModule,
    SdvorReferenceShellModule,
    SdvorBetonShellModule,
    SdvorSeoShellModule,
    CallbackShellModule,
    ShopShellEagerModule,
  ],
  exports: [SdvorMainShellModule, AnalyticsShellModule],
})
export class SpartacusFeaturesModule {}
